import { createContext, useContext } from "react";

import type { SigningFile, SigningListItem } from "./types";

/** What the page can open: a list row or a file from the detail panel. */
export interface SigningPreviewApi {
  /** Document id whose file is downloading for the viewer, if any. */
  openingId: number | null;
  /** Whether the row opens anywhere (viewer or signature panel). */
  canOpenItem: (item: SigningListItem) => boolean;
  /** Whether the row is a signed container, which opens the signature panel. */
  isContainerItem: (item: SigningListItem) => boolean;
  openItem: (item: SigningListItem) => void;
  canOpenFile: (file: SigningFile) => boolean;
  openFile: (file: SigningFile) => void;
}

export const SigningPreviewContext = createContext<SigningPreviewApi | null>(null);

/** `null` outside a provider — callers then simply offer no open action. */
export function useSigningPreview(): SigningPreviewApi | null {
  return useContext(SigningPreviewContext);
}
